import React, { useState } from 'react'
import { Box, Button, Grid, makeStyles } from '@material-ui/core'
import { FormControl, FormHelperText, TextField } from '@mui/material'
import TrovityAssistanceImage from 'src/assets/AddedServices/Marriage/trovityAssistancecimage.svg'
import sakshiImage from 'src/assets/AddedServices/Marriage/sakshi.svg'
import InputAdornment from '@mui/material/InputAdornment'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import { NAME_REGEX, PHONE_REGEX } from 'src/utils/constants/BuyPolicyMotor'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import {
  CONTACT_FORM_ERROR_MESSAGES,
  DashboardEmailsEnums,
  InsurancePolicies,
} from 'src/utils/constants/ValueAddedServicesData'
import {
  getFormControlErrorText,
  isFormControlError,
} from 'src/services/formHelperService'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { useDispatch, useSelector } from 'react-redux'
import { useMutation } from '@apollo/client'
import { RAISE_REQUEST } from 'src/services/individualService'
import { showNotificationMessage } from 'src/actions'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { scrollToComponent } from 'src/utils/commonMethods'
import LoadingModal from 'src/components/common/LoadingModal'
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers'
import {
  FINANCIAL_PROTECTION_NOTIFICATION,
  NOTIFICATION_SETTINGS_MSG,
} from 'src/utils/constants/Individual'

const Marriage = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { loggedInUserInfo } = useSelector((state) => {
    return {
      loggedInUserInfo: state?.userInfo,
    }
  })
  const [raiseRequest, { loading }] = useMutation(RAISE_REQUEST(), {
    onCompleted: () => {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.SUCCESS,
          message: FINANCIAL_PROTECTION_NOTIFICATION,
        })
      )
      contactForm.resetForm({
        ...initialValues,
      })
    },
    onError: () => {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message:
            NOTIFICATION_SETTINGS_MSG?.ENCOUNTERED_ERROR_ON_REQUEST_RAISED,
        })
      )
    },
  })
  const initialValues = {
    name: '',
    phone: '',
    scheduledTime: undefined,
  }

  const contactForm = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      name: Yup.string()
        .required(CONTACT_FORM_ERROR_MESSAGES?.NAME_REQUIRED)
        .matches(NAME_REGEX, CONTACT_FORM_ERROR_MESSAGES?.VALID_NAME),
      phone: Yup.string()
        .required(CONTACT_FORM_ERROR_MESSAGES?.PHONE_REQUIRED)
        .matches(PHONE_REGEX, CONTACT_FORM_ERROR_MESSAGES?.VALID_PHONE)
        .max(10, CONTACT_FORM_ERROR_MESSAGES?.VALID_PHONE)
        .min(10, CONTACT_FORM_ERROR_MESSAGES?.VALID_PHONE),
      scheduledTime: Yup.date().required(
        CONTACT_FORM_ERROR_MESSAGES?.SCHEDULED_TIME
      ),
    }),
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true)
      handleSubmit(values)
    },
    enableReinitialize: true,
  })

  const [isClickHere, setIsClickHere] = useState(false)

  const handleSubmit = (values) => {
    raiseRequest({
      variables: {
        emailsDetails: {
          emailType: DashboardEmailsEnums?.FINANCIAL_SECURITY,
          name: values?.name,
          phoneNumber: values?.phone,
          email: loggedInUserInfo?.userInfo?.userData?.emailId,
          preferredTime: dayjs(values?.scheduledTime).format(
            'YYYY-MMMM-DD, h:mm A'
          ),
        },
      },
    })
  }

  const handleFollowUpDateTimeChange = (event) => {
    contactForm.setFieldValue('scheduledTime', event?.format(), true)
  }

  const getDateTime = () => {
    if (contactForm?.values?.scheduledTime) {
      return dayjs(contactForm?.values?.scheduledTime)
    }
    return null
  }

  const clickHereAction = () => {
    if (isClickHere) {
      setIsClickHere(false)
    } else {
      setIsClickHere(true)
      scrollToComponent('trovity-assistance-image')
    }
  }

  const handleInsuranceBuyClick = (url) => {
    window.open(url, '_self')
  }
  return (
    <>
      <LoadingModal loading={loading} />

      <Box className={classes.animatedItem}>
        <Grid container spacing={5} className={classes.gridContainer}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Grid container className={classes.marriageTaleGridMainContainer}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className={'pb-0'}
              >
                <Grid
                  container
                  spacing={0}
                  className={classes.marriageTaleGridContainer}
                >
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={5}
                    lg={5}
                    xl={5}
                    className={classes.secureMarrigeText}
                  >
                    <br />
                    <br />
                    <Box className={classes.marriageText}>
                      <span className={classes.redColoredText}>Marriage</span>:
                      Secure Your New Beginning
                    </Box>
                    <br />
                    <br />
                    <Box className={classes.afterMarriageText}>
                      <span className={classes.redColoredText}>
                        After Marriage
                      </span>
                      <span className={classes.boldText}>
                        : Planning Honeymoon?
                      </span>
                    </Box>
                    <Box className={classes.thoughtOfFamilyText}>
                      Have You Thought of Securing Your New Family & Future?
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={4}
                    lg={3}
                    xl={3}
                    className={classes.womenimage}
                  >
                    <Box>
                      <img
                        src={sakshiImage}
                        alt='womenImage'
                        className={classes.womenImage}
                      />
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={4}
                    lg={4}
                    xl={4}
                    className={classes.clickHereGrid}
                  >
                    <Box className={classes.sakshiTaleText}>
                      Sakshi&apos;s Tale
                    </Box>
                    <Box className={classes.clickHereLinkContainer}>
                      <Box
                        className={classes.linkContainer}
                        onClick={() => {
                          clickHereAction()
                        }}
                      >
                        {/* spans are for animation*/}
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <Box>
                          <u className={classes.clickHereLink}>
                            Click Here to know
                          </u>
                        </Box>
                        <Box className={classes.howTrovityTxt}>
                          How Trovity assisted Sakshi
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className={classes.storyGrid}
              >
                <Box className={classes.storyBox}>
                  After a year of marriage,&nbsp;
                  <span className={classes.redColoredText}>
                    a tragic accident
                  </span>{' '}
                  left her with a baby and a hefty home loan burden because her
                  husband had no insurance.
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Grid container spacing={2} id='trovity-assistance-image'>
              {isClickHere ? (
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Box id='trovity-assistance-image'>
                    <img
                      src={TrovityAssistanceImage}
                      alt='TrovityAssistanceImage'
                      className={classes.trovityAssistanceImage}
                    />
                  </Box>
                </Grid>
              ) : null}
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid
                  container
                  spacing={2}
                  className={
                    !isClickHere
                      ? `${classes.contactUsGridContainer}`
                      : `${classes.contactUsGridPinkContainer}`
                  }
                >
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className={classes.contactText}
                  >
                    <Box className={classes.connectWithText}>Connect with</Box>
                    <Box className={classes.connectWithText}>
                      <span className={classes.boldText}>
                        Trovity&apos;s Financial Protection Guidance{' '}
                      </span>
                      <span>for Newlyweds and Married Couples.</span>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <form>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <Grid
                            container
                            spacing={2}
                            className={classes.contactUsGridInputContainer}
                          >
                            <Grid item>
                              <FormControl>
                                <TextField
                                  name='name'
                                  label='Name *'
                                  placeholder='  Name *'
                                  size='small'
                                  fullWidth
                                  className={classes.customTextField}
                                  value={contactForm.values.name}
                                  onChange={contactForm.handleChange}
                                  onBlur={contactForm.handleBlur}
                                  error={isFormControlError(
                                    contactForm,
                                    'name'
                                  )}
                                  helperText={getFormControlErrorText(
                                    contactForm,
                                    'name'
                                  )}
                                />
                              </FormControl>
                            </Grid>
                            <Grid item>
                              <FormControl
                                fullWidth
                                className={classes.formControlStyles}
                              >
                                <TextField
                                  name='phone'
                                  label='Phone *'
                                  size='small'
                                  type='number'
                                  startAdornment={
                                    <InputAdornment position='end'>
                                      Phone *
                                    </InputAdornment>
                                  }
                                  fullWidth
                                  className={classes.customTextField}
                                  value={contactForm.values.phone}
                                  onChange={(event) => {
                                    event.target.value = Math.max(
                                      0,
                                      parseInt(event.target.value)
                                    )
                                      .toString()
                                      .slice(0, 10)
                                    contactForm.setFieldValue(
                                      'phone',
                                      event.target.value,
                                      false
                                    )
                                  }}
                                  onBlur={contactForm.handleBlur}
                                  error={isFormControlError(
                                    contactForm,
                                    'phone'
                                  )}
                                  helperText={getFormControlErrorText(
                                    contactForm,
                                    'phone'
                                  )}
                                />
                              </FormControl>
                            </Grid>
                            <Grid item>
                              <FormControl className={classes.formControlTable}>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <DateTimePicker
                                    orientation='landscape'
                                    id='dateTimePicker'
                                    slotProps={{ textField: { size: 'small' } }}
                                    label='Preferred Time *'
                                    minDateTime={dayjs()}
                                    views={[
                                      'year',
                                      'month',
                                      'day',
                                      'hours',
                                      'minutes',
                                    ]}
                                    onChange={handleFollowUpDateTimeChange}
                                    value={getDateTime()}
                                    viewRenderers={{
                                      hours: renderTimeViewClock,
                                      minutes: renderTimeViewClock,
                                      seconds: renderTimeViewClock,
                                    }}
                                  />
                                </LocalizationProvider>

                                {isFormControlError(
                                  contactForm,
                                  'scheduledTime'
                                ) ? (
                                  <FormHelperText className={classes.errorText}>
                                    {getFormControlErrorText(
                                      contactForm,
                                      'scheduledTime'
                                    )}
                                  </FormHelperText>
                                ) : null}
                              </FormControl>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className={classes.submitButtonGrid}
                        >
                          <Box className={classes.submitBtn}>
                            <Button
                              className={classes.submitButton}
                              onClick={() => {
                                contactForm.submitForm()
                              }}
                            >
                              Submit
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </form>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Box className={classes.referText}>
                      * You can also refer your friends and family.
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Grid container spacing={5} justifyContent='center'>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box className={classes.policyText}>
                  Here are some essential policies
                </Box>
                <Box className={classes.policyCrucialText}>
                  crucial to consider for the financial security they offer.
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className={classes.policyCardContainer}
              >
                {InsurancePolicies?.map((policy) => (
                  <Box
                    key={policy?.id}
                    flex={1}
                    className={classes.essentialPolicies}
                  >
                    <Box flex={1} className={classes.insuranceImage}>
                      <img src={policy?.image} alt={`${policy?.name}`} />
                    </Box>
                    <Box flex={3} className={classes.insuranceDetails}>
                      <Box className={classes.insuranceName}>
                        {policy?.name}
                      </Box>
                      <Box className={classes.insuranceCovergeText}>
                        {policy?.coverageText}
                      </Box>
                      <Box className={classes.insuranceCovergeBoldText}>
                        {policy?.coverageBoldText}
                      </Box>
                    </Box>
                    <Box flex={1}>
                      <Button
                        className={classes.buyNowButton}
                        onClick={() => handleInsuranceBuyClick(policy?.link)}
                      >
                        Buy Now
                      </Button>
                    </Box>
                  </Box>
                ))}
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Box>
              <span className={classes.disclaimerHeading}>Disclaimer:</span>{' '}
              <br />
              <span className={classes.disclaimerText}>
                The information within this application is provided as a service
                for users informational purposes. Please note that advice may
                vary depending on different factors. We cannot guarantee the
                accuracy, adequacy, or completeness of the information provided
                here.
              </span>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
export default Marriage

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  essentialPolicies: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #EF669B',
    borderRadius: '5px',
    alignItems: 'space-around',
    justifyContent: 'space-around',
    textAlign: 'center',
    gap: '5px',
    width: '100%',
    padding: '15px 20px !important',
    maxWidth: '120px',
    minWidth: '120px',
  },
  submitBtn: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'flexStart',
  },
  marriageText: {
    fontSize: '20px',
  },
  insuranceImage: {
    padding: '10px',
    paddingBottom: '0px',
    minHeight: '40px',
  },
  insuranceDetails: {
    display: 'flex',
    flexDirection: 'column',
  },
  insuranceName: {
    fontWeight: 'bold',
    fontSize: '14px',
    paddingBottom: '10px',
    overflow: 'hidden',
    textOverflow: 'ellipsis !important',
    whiteSpace: 'nowrap',
  },
  insuranceCovergeText: {
    fontSize: '12px',
  },
  insuranceCovergeBoldText: {
    fontWeight: 'bold',
    fontSize: '12px',
  },

  redColoredText: {
    color: '#F75B5B',
  },
  sakshiTaleText: {
    fontFamily: 'Salsa',
    fontSize: '26px',
    fontWeight: 'bold',
    color: '#F75B5B',
    textAlign: 'center',
  },
  formControlTable: {
    width: '100%',
    margin: 0,
  },
  howTrovityTxt: {
    fontSize: '14px',
    fontWeight: 'bolder',
    textAlign: 'center',
  },
  boldText: {
    fontWeight: 'bold',
  },
  secureMarrigeText: {
    alignItems: 'flex-end',
    textAlign: 'right',
    '@media (max-width: 1010px)': {
      textAlign: 'center',
      padding: '10px',
    },
  },
  coupleImage: {
    maxWidth: '400px',
  },
  marriageTaleGridContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  marriageTaleGridMainContainer: {
    textAlign: 'center',
    paddingBottom: '25px',
    '@media (max-width: 1280px)': {
      gap: '100px',
    },
  },
  clickHereLink: {
    fontSize: '20px',
    fontWeight: 'bolder',
    textAlign: 'center',
    color: '#F75B5B',
  },
  clickHereLinkContainer: {
    padding: '10px 15px',
    backgroundColor: '#ffffff',
    width: '60%',
    position: 'relative',
  },
  storyGrid: {
    textAlign: 'center',
    paddingTop: '0 !important',
  },
  contactUsGridContainer: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #CECECE',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    borderRadius: '10px',
    padding: '20px',
  },
  contactUsGridPinkContainer: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #CECECE',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    borderRadius: '10px',
    backgroundColor: '#FBE2EC',
  },
  contactText: {
    alignItems: 'center',
  },
  contactUsGridInputContainer: {
    justifyContent: 'center',
  },
  submitButtonGrid: {
    justifyContent: 'center',
  },
  submitButton: {
    alignItems: 'center',
    borderRadius: '5px',
    border: '1px solid #EF669B',
    padding: '5px 25px',
    color: '#EF669B',
    fontSize: '12px',
  },
  policyText: {
    fontSize: '20px',
    fontWeight: '400',
    textAlign: 'center',
    paddingTop: '20px',
  },
  policyCrucialText: {
    fontSize: '15px',
    textAlign: 'center',
  },
  buyNowButton: {
    backgroundColor: '#EF669B',
    color: '#ffffff',
    height: '30px',
    fontSize: '12px',
    fontWeight: '500',
    padding: '10px 20px',
    '&:hover': {
      backgroundColor: '#B92250',
    },
  },
  customTextField: {
    justifyContent: 'center',
    '& .MuiInputBase-input': {
      WebkitTextFillColor: '#333333 !important',
    },
    '& .MuiInputBase-root': {},
  },
  storyBox: {
    borderRadius: '6px',
    fontSize: '14px',
    backgroundColor: '#EDEDED',
    padding: '15px 10px',
    '@media (max-width:768px)': {
      marginTop: '100px',
    },
  },
  disclaimerText: {
    fontSize: '12px',
    lineHeight: '17px',
    fontWeight: 400,
    color: '#717171',
  },
  disclaimerHeading: {
    fontSize: '12px',
    lineHeight: '17px',
    fontWeight: 700,
    color: '#000000',
  },
  referText: {
    color: '#4A4A4A',
    fontSize: '13px',
  },
  connectWithText: {
    fontSize: '14px',
  },
  connectWithBelowText: {
    fontSize: '16px',
  },
  afterMarriageText: {
    fontWeight: 'bold',
    fontSize: '16px',
  },
  thoughtOfFamilyText: {
    fontSize: '14px',
  },
  clickHereContainer: {
    textAlign: 'center',
    borderRadius: '10px',
    padding: '10px',
    cursor: 'pointer',
  },
  '%full-fill': {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,

    '&::after': {
      content: '',
      zIndex: -1,
      margin: '-1 * .05 * 100%',
      boxShadow: 'inset 0 0 0 2px',
      animation: '$clipMe 8s linear infinite',
    },

    '&::before': {
      animationDelay: '8s * -.5',
    },
  },

  errorText: {
    maxWidth: '200px',
    color: '#d32f2f !important',
    fontSize: '12px',
    marginTop: 'unset !important',
  },
  policyCardContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '10px',
  },

  errorStyle: {
    color: 'red !important',
  },
  womenImage: { width: '100%' },
  trovityAssistanceImage: {
    width: '100%',
  },
  animatedItem: {
    animation: `$slideEffect 500ms ${theme.transitions.easing.easeInOut}`,
  },
  '@keyframes slideEffect': {
    '0%': {
      opacity: 0,
      transform: 'translateX(-10%)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateX(0%)',
    },
  },
  '@keyframes colorChange': {
    '0%': { boxShadow: '0px 0px 0px 0px red' },
    '25%': { boxShadow: '20px 0px 0px 0px red' },
    '50%': { boxShadow: '0px 0px 0px 0px red' },
    '75%': { boxShadow: '-20px 0px 0px 0px red' },
    '100%': { boxShadow: '0px 0px 0px 0px red' },
  },
  linkContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '100%',
    border: '2px solid transparent',
    backgroundColor: 'transparent',
    transform: 'translate(-50%, -50%)',
    overflow: 'hidden',
    padding: '10px 20px',
    marginTop: '50px',
    boxShadow: '0 20px 50px rgb(255 255 255 / 5%)',
    '& span:nth-child(1)': {
      position: 'absolute',
      width: '100%',
      height: '5px',
      top: '0',
      left: '0',
      background: 'linear-gradient(to right, #fa8072 , #e9967a)',
      animation: '$animate1 2s linear infinite',
    },
    '& span:nth-child(2)': {
      position: 'absolute',
      width: '5px',
      height: '100%',
      top: '0',
      right: '0',
      background: 'linear-gradient(to bottom,  #fa8072 , #e9967a)',
      animation: '$animate2 2s linear infinite',
      animationDelay: '1s',
    },
    '& span:nth-child(3)': {
      position: 'absolute',
      width: '100%',
      height: '5px',
      left: '0',
      bottom: '0',
      background: 'linear-gradient(to left,  #fa8072 , #e9967a)',
      animation: '$animate3 2s linear infinite',
    },
    '& span:nth-child(4)': {
      position: 'absolute',
      width: '5px',
      height: '100%',
      top: '0',
      left: '0',
      background: 'linear-gradient(to top,  #fa8072 , #e9967a)',
      animation: '$animate4 2s linear infinite',
      animationDelay: '1s',
    },
  },
  '@keyframes animate1': {
    '0%': {
      transform: 'translateX(-100%)',
    },
    '100%': {
      transform: 'translateX(100%)',
    },
  },
  '@keyframes animate2': {
    '0%': {
      transform: 'translateY(-100%)',
    },
    '100%': {
      transform: 'translateY(100%)',
    },
  },
  '@keyframes animate3': {
    '0%': {
      transform: 'translateX(100%)',
    },
    '100%': {
      transform: 'translateX(-100%)',
    },
  },
  '@keyframes animate4': {
    '0%': {
      transform: 'translateY(100%)',
    },
    '100%': {
      transform: 'translateY(-100%)',
    },
  },
  clickHereGrid: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  formControlStyles: {
    margin: 0,
  },
}))
